import {ErrorBoundaryWrapper} from "../../error-boundary/error-boundary-wrapper";
import {ExternalAdContent} from "./external-ad.content";
import {observer} from "mobx-react";

export const ExternalAd = observer(({controller, ...rest}) => {
  const isBlockByRoute = !controller.state.currentLinkModel?.name || controller.state.appState.isBettingPage;

  if (!window.googletag || isBlockByRoute) {
    return null;
  }

  return <ErrorBoundaryWrapper>
    <ExternalAdContent {...rest} controller={controller}/>
  </ErrorBoundaryWrapper>
});

